module.exports = __webpack_public_path__ + "img/332-c4e1b4.png";